import { render, staticRenderFns } from "./cModalHistorialPagos.vue?vue&type=template&id=71089ab4"
import script from "./cModalHistorialPagos.vue?vue&type=script&lang=js"
export * from "./cModalHistorialPagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports